import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MEMBERSHIP_BADGE = defineFcm('membership_badge')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				disable_for_users: {
					type: 'array',
					shape: {
						type: 'number',
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.withMerger(({ globalValue, countryValue }) => {
		let enabled = !!globalValue?.enabled;
		// eslint-disable-next-line @typescript-eslint/naming-convention
		let disable_for_users = globalValue?.disable_for_users ?? [];
		if (countryValue) {
			enabled = countryValue.enabled;
			disable_for_users = [...disable_for_users, ...countryValue.disable_for_users];
		}

		return {
			enabled,
			disable_for_users,
		};
	})
	.toConfig();
